import { setText } from './dom';

export async function copyText(value: string, button: HTMLButtonElement): Promise<void> {
	const original = button.textContent;
	try {
		await navigator.clipboard.writeText(value);
		setText(button, 'Copied');
	} catch {
		setText(button, 'Copy failed');
	}
	window.setTimeout(() => setText(button, original || 'Copy'), 1600);
}
